if (!customElements.get('cart-progress')) {
  class cartProgress extends HTMLElement {
    constructor() {
      super();

      this.cartTotal = parseFloat(this.dataset.cartTotal);
      this.freeShipPrice = this.dataset.freeshipPrice;
      this.progressBar = this.querySelector('.progress-bar');
      this.progressHeader = this.querySelector('.progress-bar-header');

      this.offerOnePrice = this.dataset.offerOne;
      this.offerTwoPrice = this.dataset.offerTwo;

      this.offerZeroText = this.dataset.freeshipPriceText;
      this.offerOneText = this.dataset.offerOneText;
      this.offerTwoText = this.dataset.offerTwoText;
 
      this.init();
    }

    triggerConfetti = () => {
      const parent = this.closest('mini-cart') || document.body;
      const isDrawer = parent.tagName.toLowerCase() === 'mini-cart';

      const canvas = document.createElement('canvas');
      canvas.style.position = isDrawer ? 'absolute' : 'fixed';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.zIndex = '999999';
      canvas.style.pointerEvents = 'none';
      parent.appendChild(canvas);

      const ctx = canvas.getContext('2d');
      let rect = parent.getBoundingClientRect();
      let width = canvas.width = isDrawer ? (rect.width || 450) : window.innerWidth;
      let height = canvas.height = isDrawer ? (rect.height || window.innerHeight) : window.innerHeight;

      const handleResize = () => {
        let r = parent.getBoundingClientRect();
        width = canvas.width = isDrawer ? (r.width || 450) : window.innerWidth;
        height = canvas.height = isDrawer ? (r.height || window.innerHeight) : window.innerHeight;
      };
      window.addEventListener('resize', handleResize);

      const colors = ['#00b9aa', '#fb1d8a', '#ffcd7d', '#52b6aa', '#002D46', '#e22120'];
      const confettiCount = 150;
      const particles = [];

      class Particle {
        constructor() {
          this.x = Math.random() * width;
          this.y = isDrawer ? (Math.random() * -150 - 10) : (Math.random() * -height - 20);
          this.rotation = Math.random() * 360;
          this.rotationSpeed = Math.random() * 8 - 4;
          this.size = Math.random() * 8 + 6;
          this.color = colors[Math.floor(Math.random() * colors.length)];
          this.speedY = Math.random() * 5 + 3;
          this.speedX = isDrawer ? (Math.random() * 3 - 1.5) : (Math.random() * 4 - 2);
        }

        update() {
          this.y += this.speedY;
          this.x += this.speedX;
          this.rotation += this.rotationSpeed;
        }

        draw() {
          ctx.save();
          ctx.translate(this.x, this.y);
          ctx.rotate(this.rotation * Math.PI / 180);
          ctx.fillStyle = this.color;
          ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size);
          ctx.restore();
        }
      }

      for (let i = 0; i < confettiCount; i++) {
        particles.push(new Particle());
      }

      let animationFrameId;
      const animate = () => {
        ctx.clearRect(0, 0, width, height);
        let allFinished = true;

        particles.forEach(p => {
          p.update();
          p.draw();
          if (p.y < height + 20) {
            allFinished = false;
          }
        });

        if (!allFinished) {
          animationFrameId = requestAnimationFrame(animate);
        } else {
          cleanup();
        }
      };

      const cleanup = () => {
        window.removeEventListener('resize', handleResize);
        if (canvas.parentNode) {
          canvas.remove();
        }
      };

      animate();

      setTimeout(() => {
        cancelAnimationFrame(animationFrameId);
        cleanup();
      }, 4000);
    }

    initProgressBar = () => {
      // 1. Parse active milestone limits and map them
      const limits = [
        parseInt(this.freeShipPrice),
        parseInt(this.offerOnePrice),
        parseInt(this.offerTwoPrice)
      ].filter(val => !isNaN(val) && val > 0);

      const milestoneElements = [
        this.querySelector('[data-mileston-zero]'),
        this.querySelector('[data-mileston-one]'),
        this.querySelector('[data-mileston-two]')
      ].filter(Boolean);

      const totalMilestones = milestoneElements.length;

      // 2. Position the milestones dynamically and set active/inactive classes
      milestoneElements.forEach((el, index) => {
        const percent = ((index + 1) / totalMilestones) * 100;
        el.style.position = 'absolute';
        el.style.left = `${percent}%`;
        el.style.transform = 'translateX(-50%)';

        const limit = limits[index];
        if (this.cartTotal >= limit) {
          el.classList.add('filled');
        } else {
          el.classList.remove('filled');
        }
      });

      // 3. Calculate progress bar fill percentage
      let fillPercentage = 0;
      if (limits.length === 1) {
        fillPercentage = Math.min((this.cartTotal / limits[0]) * 100, 100);
      } else if (limits.length === 2) {
        const limit1 = limits[0];
        const limit2 = limits[1];
        if (this.cartTotal <= 0) {
          fillPercentage = 0;
        } else if (this.cartTotal <= limit1) {
          fillPercentage = (this.cartTotal / limit1) * 50;
        } else if (this.cartTotal <= limit2) {
          fillPercentage = 50 + ((this.cartTotal - limit1) / (limit2 - limit1)) * 50;
        } else {
          fillPercentage = 100;
        }
      } else if (limits.length === 3) {
        const limit1 = limits[0];
        const limit2 = limits[1];
        const limit3 = limits[2];
        if (this.cartTotal <= 0) {
          fillPercentage = 0;
        } else if (this.cartTotal <= limit1) {
          fillPercentage = (this.cartTotal / limit1) * 33.33;
        } else if (this.cartTotal <= limit2) {
          fillPercentage = 33.33 + ((this.cartTotal - limit1) / (limit2 - limit1)) * 33.33;
        } else if (this.cartTotal <= limit3) {
          fillPercentage = 66.66 + ((this.cartTotal - limit2) / (limit3 - limit2)) * 33.34;
        } else {
          fillPercentage = 100;
        }
      }

      if (this.progressBar) {
        this.progressBar.style.display = 'block';
        this.progressBar.style.width = `${fillPercentage}%`;
      }

      // 4. Update the header message
      let headerHtml = '';
      if (limits.length === 2) {
        const limit1 = limits[0];
        const limit2 = limits[1];
        if (this.cartTotal < limit1) {
          const remaining = limit1 - this.cartTotal;
          const label = this.offerZeroText || '10% off';
          headerHtml = `Add <strong>${remaining}</strong> more product${remaining > 1 ? 's' : ''} to get <strong>${label}</strong>`;
        } else if (this.cartTotal < limit2) {
          const remaining = limit2 - this.cartTotal;
          const label = this.offerOneText || '15% off';
          headerHtml = `Add <strong>${remaining}</strong> more product${remaining > 1 ? 's' : ''} to get <strong>${label}</strong>`;
        } else {
          headerHtml = `You have unlocked all rewards!`;
        }
      } else if (limits.length === 3) {
        const limit1 = limits[0];
        const limit2 = limits[1];
        const limit3 = limits[2];
        if (this.cartTotal < limit1) {
          const remaining = limit1 - this.cartTotal;
          headerHtml = `Add <strong>${remaining}</strong> more product${remaining > 1 ? 's' : ''} to get <strong>${this.offerZeroText}</strong>`;
        } else if (this.cartTotal < limit2) {
          const remaining = limit2 - this.cartTotal;
          headerHtml = `Add <strong>${remaining}</strong> more product${remaining > 1 ? 's' : ''} to get <strong>${this.offerOneText}</strong>`;
        } else if (this.cartTotal < limit3) {
          const remaining = limit3 - this.cartTotal;
          headerHtml = `Add <strong>${remaining}</strong> more product${remaining > 1 ? 's' : ''} to get <strong>${this.offerTwoText}</strong>`;
        } else {
          headerHtml = `You have unlocked all rewards!`;
        }
      } else if (limits.length === 1) {
        const limit1 = limits[0];
        if (this.cartTotal < limit1) {
          const remaining = limit1 - this.cartTotal;
          headerHtml = `Add <strong>${remaining}</strong> more product${remaining > 1 ? 's' : ''} to get <strong>${this.offerZeroText}</strong>`;
        } else {
          headerHtml = `You have unlocked all rewards!`;
        }
      }

      if (this.progressHeader) {
        this.progressHeader.innerHTML = headerHtml;
      }

      // 5. Track changes and trigger confetti when milestone 2 or 3 is reached
      const prevCartTotalStr = sessionStorage.getItem('prev_cart_total');
      const currentTotal = Math.round(this.cartTotal);

      if (prevCartTotalStr !== null) {
        const prevVal = parseInt(prevCartTotalStr);
        if (currentTotal > prevVal && (currentTotal === 2 || currentTotal === 3)) {
          this.triggerConfetti();
        }
      }
      sessionStorage.setItem('prev_cart_total', currentTotal.toString());

      // 6. Check and apply milestone manual discounts (2 items -> "5%OFF", 3+ items -> "7%OFF")
      const appliedDiscounts = (this.dataset.appliedDiscounts || '')
        .toUpperCase()
        .split(',')
        .map(d => d.trim())
        .filter(Boolean);

      if (currentTotal === 2) {
        if (!appliedDiscounts.includes('5%OFF')) {
          this.updateCartDiscount('5%OFF');
        }
      } else if (currentTotal >= 3) {
        if (!appliedDiscounts.includes('7%OFF')) {
          this.updateCartDiscount('7%OFF');
        }
      } else {
        if (appliedDiscounts.includes('5%OFF') || appliedDiscounts.includes('7%OFF')) {
          this.updateCartDiscount('');
        }
      }
    }

    updateCartDiscount = async (discountCode) => {
      if (window.isUpdatingMilestoneDiscount) return;
      window.isUpdatingMilestoneDiscount = true;

      const cartItemsEl = document.querySelector('cart-items') || document.querySelector('mini-cart');
      if (cartItemsEl && typeof cartItemsEl.enableLoading === 'function') {
        cartItemsEl.enableLoading();
      }

      try {
        const miniCart = document.querySelector('mini-cart');
        const sections = miniCart ? miniCart.getSectionsToRender().map(s => s.id) : ["mini-cart", "cart-icon-bubble", "mobile-cart-icon-bubble"];
        
        let routes = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        if (routes !== '/' && !routes.endsWith('/')) routes += '/';

        const response = await fetch(routes + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            discount: discountCode,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });

        const data = await response.json();

        if (miniCart && typeof miniCart.renderContents === 'function' && data.sections) {
          miniCart.renderContents(data);
        } else if (data.sections) {
          sections.forEach(secId => {
            const el = document.getElementById(secId);
            if (el && data.sections[secId]) {
              const dummy = document.createElement('div');
              dummy.innerHTML = data.sections[secId];
              const inner = dummy.querySelector('.shopify-section') || dummy;
              el.innerHTML = inner.innerHTML;
            }
          });
        }
        
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      } catch (error) {
        console.error('Error updating milestone discount:', error);
      } finally {
        if (cartItemsEl && typeof cartItemsEl.disableLoading === 'function') {
          cartItemsEl.disableLoading();
        }
        window.isUpdatingMilestoneDiscount = false;
      }
    }

    init = () => {
      this.initProgressBar();
    }
  }
  customElements.define('cart-progress', cartProgress);
}